import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
const bonuses = [{
  num: 1,
  title: '"El Código del Placer Femenino"',
  subtitle: 'Los Puntos Exactos que la Hacen Explotar de Placer',
  image: 'https://cdn.magicpatterns.com/uploads/qAXezjGzAmQhKgQmQeXvpw/a5d76548-2522-4654-a7b8-8286f7c4471b.jpg',
  learnings: ['Mapa completo de sus zonas erógenas secretas (que el 90% no conoce)', 'Las 3 fases del orgasmo femenino y cómo intensificar cada una', 'Cómo leer perfectamente sus señales corporales', 'Técnicas probadas para orgasmos múltiples garantizados']
}, {
  num: 2,
  title: '"Cómo Usar Tus Dedos Como un Experto"',
  subtitle: 'Técnicas Sexuales que la Dejan Sin Aliento',
  image: 'https://cdn.magicpatterns.com/uploads/vPPgFLbUNB4FXKjdFMAZJt/Captura_de_pantalla_2026-04-15_a_la(s)_5.47.37_p._m..png',
  learnings: ['Los 5 movimientos con los dedos que nunca fallan', 'Combinaciones letales de dedos + lengua para máximo placer', 'El punto G: cómo encontrarlo y estimularlo perfectamente', 'Técnicas avanzadas para el orgasmo del punto A (pocos lo conocen)']
}, {
  num: 3,
  title: '"Hazla Venir con Tu Lengua"',
  subtitle: 'La Técnica Secreta Lésbica que Ningún Hombre Conoce',
  image: 'https://cdn.magicpatterns.com/uploads/eZiQu9q12H3NKMz6y6xXzN/Captura_de_pantalla_2026-04-15_a_la(s)_5.45.26_p._m..png',
  learnings: ['Los 7 movimientos exactos que la vuelven loca de placer', 'Dónde tocar y con qué presión específica', 'El secreto de las "ondas múltiples" para orgasmos consecutivos', 'Cómo hacer que te ruegue por más cada vez']
}];
export function Bonuses() {
  return <section className="py-16 px-4 bg-black relative border-t border-gray-900" data-id="element-38">
      <div className="max-w-6xl mx-auto" data-id="element-39">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-40">
          <span className="text-6xl mb-6 block" data-id="element-41">🎁</span>
          <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-42">
            BONUSES EXCLUSIVOS
          </h2>
          <p className="text-2xl text-brand-gold font-light" data-id="element-43">
            3 Regalos que multiplican tu poder sexual
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-3 gap-8 mb-10" data-id="element-44">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-brand-card border border-brand-red/20 rounded-2xl p-8 relative overflow-hidden group hover:border-brand-red/50 transition-colors flex flex-col" data-id="element-45">
              <div className="absolute top-0 right-0 bg-brand-red text-white font-bold px-6 py-1 rounded-bl-xl z-10" data-id="element-46">
                HOY: GRATIS
              </div>

              <div className="absolute -top-10 -right-10 text-9xl opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-47">
                🔥
              </div>

              <div className="relative z-10 flex-1 flex flex-col" data-id="element-48">
                <span className="text-brand-red font-bold tracking-widest uppercase text-sm mb-2 block" data-id="element-49">
                  BONUS #{bonus.num}
                </span>
                <h3 className="text-2xl font-oswald font-bold text-white mb-2" data-id="element-50">
                  {bonus.title}
                </h3>
                <p className="text-gray-400 text-sm mb-6 pb-6 border-b border-gray-800" data-id="element-51">
                  {bonus.subtitle}
                </p>

                <div className="w-full aspect-[4/3] rounded-xl border border-gray-800 mb-8 overflow-hidden" data-id="element-52">
                  {bonus.image ? <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover" data-id="element-53" /> : <div className="w-full h-full bg-gray-900 flex items-center justify-center" data-id="element-54">
                      <span className="text-gray-600 font-medium" data-id="element-55">
                        Mockup Libro {bonus.num}
                      </span>
                    </div>}
                </div>

                <div className="mt-auto pt-6 border-t border-gray-800 flex justify-between items-center" data-id="element-56">
                  <span className="text-gray-500 line-through" data-id="element-57">
                    Valor: $19.990
                  </span>
                  <span className="text-green-500 font-bold bg-green-500/10 px-2 py-1 rounded" data-id="element-58">
                    GRATIS
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-brand-card to-black border border-brand-gold/30 p-8 rounded-2xl text-center max-w-3xl mx-auto mb-10" data-id="element-59">
          <p className="text-gray-400 text-lg mb-2" data-id="element-60">
            VALOR TOTAL DEL PAQUETE COMPLETO:{' '}
            <span className="line-through" data-id="element-61">$79.960</span>
          </p>
          <p className="text-3xl md:text-4xl font-oswald text-white mb-2" data-id="element-62">
            PRECIO ESPECIAL HOY:{' '}
            <span className="text-brand-gold font-bold bg-brand-gold/10 px-2 rounded" data-id="element-63">
              $19.990
            </span>
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-64">
          <Button data-id="element-65">QUIERO EL MÉTODO</Button>
        </motion.div>
      </div>
    </section>;
}